import { render, staticRenderFns } from "./GrammarExplanation.vue?vue&type=template&id=9b30550e&"
import script from "./GrammarExplanation.vue?vue&type=script&lang=js&"
export * from "./GrammarExplanation.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports